import API from '../../../../../../../libs/api';
import { VIDEO_BLOCK_COMPONENT_NAME } from '../../../../constants/types';

export async function updateComponentConfiguration(componentConfigurationId, payload) {
  const componentConfigurationData = { ...payload, id: componentConfigurationId };
  return API.updateCustomPageContent(componentConfigurationData);
}

export async function createComponentConfiguration(pageId, { data }) {
  const payload = {
    data,
    content_node_configurations: [],
    business_file_configurations: [],
    component: VIDEO_BLOCK_COMPONENT_NAME,
    page: pageId,
  };
  const { data: results } = await API.createCustomPageContent(payload);

  return results[0];
}

export function updateVideoComponentFromSave(currentElement, businessFiles, result) {
  const {
    fast_id: componentName,
    component_identifier: componentIdentifier,
    id: newComponentConfigurationId,
    data: {
      video: { videoId, source, url, placeholder },
    },
  } = result;
  const placeholderFile = businessFiles.find(({ file }) => file === placeholder);

  return {
    ...currentElement,
    componentName,
    componentIdentifier,
    componentConfigurationId: newComponentConfigurationId,
    videoId,
    source,
    url,
    placeholderFile,
  };
}
